<template>
  <collapse-transition>
    <ul :class="classes">
      <li>
        <span :class="titleClasses">
          <van-checkbox
            v-if="showCheckbox"
            :value="data.checked"
            shape="round"
            :disabled="data.disabled || data.disableCheckbox"
            @click.stop="handleCheck"
          />
          <span :class="arrowClasses" @click="handleExpand">
            <!-- <Icon v-if="showArrow" type="arrow-right"></Icon> -->
            <Icon v-if="showLoading" type="loading" class="load-loop"></Icon>
            <Icon v-else :class="[hideArrowRight && 'unvisiable']" type="arrow-right"></Icon>
          </span>
          <span class="content" @click="handleClick">
            <span class="name ellipsis">
              <span class="ellipsis flex-center">
                {{ data.name }}
                <img src="https://p3.ssl.qhimg.com/t110b9a9301c3f35e4fbd4de83a.png" alt="" v-if="!data.has_permission && data.isDoclib">
              </span>
              <span v-if="showUserCount" class="user-count">({{$t('base.person', [data.user_count])}})</span>
            </span>
            <Icon v-if="showArrowNext" type="arrow-next"/>
          </span>
        </span>

        <Tree-node
            v-if="data.expand"
            v-for="(item, i) in children"
            :key="i"
            :data="item"
            :multiple="multiple"
            :show-checkbox="showCheckbox"
            :show-arrow-next="showArrowNext"
            :show-user-count="showUserCount"
            :children-key="childrenKey">
        </Tree-node>
      </li>
    </ul>
  </collapse-transition>
</template>
<script>
import Icon from './Icon.vue'
import CollapseTransition from '@/utils/collapse-transition'
import Emitter from '../mixins/emitter'
import findComponentUpward from '@/utils/findComponentUpward'

const prefixCls = 'tree'

export default {
  name: 'TreeNode',
  mixins: [ Emitter ],
  components: { Icon, CollapseTransition },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    childrenKey: {
      type: String,
      default: 'children'
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    showArrowNext: {
      type: Boolean,
      default: false
    },
    showUserCount: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      prefixCls: prefixCls
    }
  },
  computed: {
    classes () {
      return [
        `${prefixCls}-children`
      ]
    },
    selectedCls () {
      return [
        {
          [`${prefixCls}-node-selected`]: this.data.selected
        }
      ]
    },
    hideArrowRight () {
      return this.data.disabled || !this.data[this.childrenKey]
    },
    arrowClasses () {
      return [
        `${prefixCls}-arrow`,
        {
          [`${prefixCls}-arrow-open`]: this.data.expand
        }
      ]
    },
    titleClasses () {
      return [
        `${prefixCls}-title`,
        {
          [`${prefixCls}-title-selected`]: this.data.selected
        }
      ]
    },
    showArrow () {
      return 'loading' in this.data && !this.data.loading
    },
    showLoading () {
      return 'loading' in this.data && this.data.loading
    },
    node () {
      const Tree = findComponentUpward(this, 'Tree')
      if (Tree) {
        // 将所有的 node（即flatState）和当前 node 都传递
        return [Tree.flatState, Tree.flatState.find(item => item.nodeKey === this.data.nodeKey)]
      } else {
        return []
      }
    },
    children () {
      return this.data[this.childrenKey]
    }
  },
  methods: {
    handleExpand (e) {
      // e.stopPropagation()
      const item = this.data
      if (item.disabled) return
      if (!item[this.childrenKey]) return

      // async loading
      if (item[this.childrenKey].length === 0) {
        const tree = findComponentUpward(this, 'Tree')
        if (tree && tree.loadData) {
          this.$set(this.data, 'loading', true)
          tree.loadData(item, children => {
            this.$set(this.data, 'loading', false)
            if (children.length) {
              this.$set(this.data, this.childrenKey, children)
              this.$nextTick(() => this.handleExpand())
            }
          })
          return
        }
      }

      if (item[this.childrenKey] && item[this.childrenKey].length) {
        this.$set(this.data, 'expand', !this.data.expand)
        this.dispatch('Tree', 'toggle-expand', this.data)
      }
    },
    handleSelect () {
      if (this.data.disabled) return
      this.dispatch('Tree', 'on-selected', this.data.nodeKey)
    },
    handleCheck () {
      if (this.data.disabled) return
      const changes = {
        checked: !this.data.checked && !this.data.indeterminate,
        nodeKey: this.data.nodeKey
      }
      this.dispatch('Tree', 'on-check', changes)
    },
    handleClick () {
      this.showCheckbox ? this.handleCheck() : this.handleSelect()
    }
  }
}
</script>
<style lang="postcss">
.name {
  & .flex-center {
    display: flex;
    align-items: center;

    & img {
      width: 14px;
      height: 14px;
      margin-left: 6px;
    }
  }
}
</style>
